import gql from 'graphql-tag';

export default {
	GET_APP_USERS_LIST: gql`
		query getAppUsersList {
			getAppUsersList
		}
	`
}